export function normalizeDisabledMenuItemIds(value) {
  if (!Array.isArray(value)) return [];
  return Array.from(new Set(value.map((id) => String(id || '').trim()).filter(Boolean)));
}

export function menuItemDisabledBySettings(node, flags = {}) {
  if (!node?.id) return false;
  return normalizeDisabledMenuItemIds(flags.disabledMenuItemIds).includes(node.id);
}

export function collectConfigurableMenuItems(nodes = [], groupTitle = '') {
  return nodes.flatMap((node) => {
    const nextGroupTitle = node.type === 'group' ? node.title || groupTitle : groupTitle;
    if (node.type === 'item' && node.url && !node.superadminOnly && node.id !== 'dashboard') {
      return [
        {
          id: node.id,
          title: node.title || node.id,
          url: node.url,
          groupTitle: nextGroupTitle || 'Navigation'
        }
      ];
    }
    if (node.children?.length) return collectConfigurableMenuItems(node.children, nextGroupTitle);
    return [];
  });
}
